<div class="section-container pt-2">
  <div [class]="'section-header mb-1 px-3 gap-2'  + (showFilter() ? ' pb-0' : ' pb-2')">
    <div class="d-flex align-items-center gap-2">
      <mat-icon class="header-icon">{{ icon() }}</mat-icon>
      <div class="header-text">
        <h5 class="m-0 fw-bold">{{ titleKey() | translate }}</h5>
      </div>
    </div>
    <div class="header-divider-wrap">
      <mat-divider class="header-divider"></mat-divider>
    </div>
    <!-- @if (countLabelKey()) {
    <div class="count-line">
      <span class="count-badge">{{ count() }}</span>
      <span class="count-label">{{ countLabelKey() | translate }}</span>
    </div>
    } -->

    <!-- filter input -->
    @if (showFilter()) {
    <div class="table-controls">
      <mat-form-field appearance="outline" class="table-filter" subscriptSizing="dynamic">
        <input matInput type="text" [value]="filterText()" autocomplete="off"
          [placeholder]="'shared.general.labels.filter_placeholder' | translate"
          (input)="setFilter($any($event.target).value)" />
        @if (filterText()) {
        <button mat-icon-button matSuffix type="button" class="clear-filter-btn" (click)="clearFilter()"
          [attr.aria-label]="'shared.general.buttons.close' | translate">
          <mat-icon>close</mat-icon>
        </button>
        } @else {
        <button mat-icon-button matSuffix type="button" class="clear-filter-btn">
          <mat-icon>search</mat-icon>
        </button>
        }
      </mat-form-field>
    </div>
    }
  </div>

  <div class="content-box">
    <div class="table-wrapper">
      <table mat-table [dataSource]="paginatedRows()" [trackBy]="trackByRow" matSort (matSortChange)="onSortChange($event)">
        @for (column of columns(); track column.key) {
        <ng-container [matColumnDef]="column.key">
          @if (column.sortable) {
          <th mat-header-cell *matHeaderCellDef [mat-sort-header]="column.key"
            [class.progress-col]="column.type === 'progress'">
            {{ column.label | translate }}
          </th>
          }
          @else {
          <th mat-header-cell *matHeaderCellDef [class.progress-col]="column.type === 'progress'">
            {{ column.label | translate }}
          </th>
          }
          <td mat-cell *matCellDef="let row" [class.progress-col]="column.type === 'progress'">
            @switch (column.type ?? 'text') {
            @case ('bool') {
            <av-bool-cell [value]="asBool(row[column.key])" />
            }
            @case ('progress') {
            @if (asProgressCell(row[column.key])?.percent !== null && asProgressCell(row[column.key])?.percent !==
            undefined) {
            <div class="d-flex align-items-center usage-row">
              <span>{{ asProgressCell(row[column.key])?.text ?? ('shared.general.labels.na' | translate) }}</span>
              <span class="ms-auto">{{ asProgressCell(row[column.key])?.percent }}%</span>
            </div>
            <div class="usage-bar-wrap">
              <mat-progress-bar mode="determinate"
                [value]="asProgressCell(row[column.key])?.percent ?? 0"></mat-progress-bar>
            </div>
            }
            @else {
            <span>{{ 'shared.general.labels.na' | translate }}</span>
            }
            }
            @case ('link') {
            @if (asLinkCell(row[column.key])?.icon) {
            <div class="link-icon-cell">
              <button mat-icon-button class="link-icon-btn" color="primary"
                [attr.aria-label]="linkAriaLabel(asLinkCell(row[column.key]), column.label)"
                (click)="handleLinkClick(asLinkCell(row[column.key]))">
                <mat-icon>{{ asLinkCell(row[column.key])?.icon }}</mat-icon>
              </button>
            </div>
            }
            @else if (asLinkCell(row[column.key])?.text) {
            @if (asLinkCell(row[column.key])?.routerLink?.length) {
            <a class="av-table-anchor-text" [routerLink]="row[column.key]?.routerLink"
              [attr.aria-label]="linkAriaLabel(asLinkCell(row[column.key]), column.label)">
              {{ linkLabel(asLinkCell(row[column.key]), column.label) }}
            </a>
            }
            @else if (asLinkCell(row[column.key])?.onClick) {
            <a class="av-table-anchor-text" href="#" role="button"
              [attr.aria-label]="linkAriaLabel(asLinkCell(row[column.key]), column.label)"
              (click)="handleAnchorClick($event, asLinkCell(row[column.key]))">
              {{ linkLabel(asLinkCell(row[column.key]), column.label) }}
            </a>
            }
            @else {
            <span>{{ linkLabel(asLinkCell(row[column.key]), column.label) }}</span>
            }
            }
            @else {
            <span>{{ 'shared.general.labels.na' | translate }}</span>
            }
            }
            @case ('copy') {
            @if (asCopyCell(row[column.key])) {
            <app-table-copy-cell [content]="asCopyCell(row[column.key])?.content ?? ''"
              [value]="asCopyCell(row[column.key])?.value"
              [tooltipText]="asCopyCell(row[column.key])?.tooltip ? (asCopyCell(row[column.key])?.tooltip | translate) : ''">
            </app-table-copy-cell>
            } @else {
            <span>{{ 'shared.general.labels.na' | translate }}</span>
            }
            }
            @default {
            <span class="d-block w-100" [matTooltip]="formatText(row[column.key])"
              [matTooltipDisabled]="!isTruncatedText(row[column.key])">
              {{ formatDisplayText(row[column.key]) }}
            </span>
            }
            }
          </td>
        </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns()"></tr>
      </table>

      @if (paginatedRows().length === 0) {
      <div class="no-data-content">
        <span>{{ emptyTextKey() | translate }}</span>
      </div>
      }
    </div>

    @if (showPagination()) {
    <mat-paginator class="pagination-bar" [length]="count()" [pageIndex]="pageIndex()" [pageSize]="pageSize()"
      [pageSizeOptions]="[pageSize()]" [hidePageSize]="true" [showFirstLastButtons]="true"
      (page)="onPageChange($event)">
    </mat-paginator>
    }
  </div>
</div>